module.exports = __webpack_public_path__ + "img/company-logo-white.f3e82bc7.svg";